import { memo } from 'react';

import { useTheme } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FormatListNumberedOutlined from '@mui/icons-material/FormatListNumberedOutlined';
import { getNameFromId, Interview } from '@synergetx/puppet-interview-types';

const InterviewListItem = ({
    interview,
    handleSelection,
}: {
    interview: Interview;
    handleSelection: (interview: Interview) => void;
}) => {
    const theme = useTheme();

    return (
        <ListItemButton
            sx={{
                pl: 2,
                py: 1,
                ':hover': {
                    backgroundColor: theme.palette.action.hover,
                },
            }}
            onClick={() => handleSelection(interview)}
        >
            <ListItemIcon sx={{ minWidth: 36 }}>
                <FormatListNumberedOutlined fontSize="small" color="action" />
            </ListItemIcon>
            <ListItemText
                primary={interview.name}
                secondary={getNameFromId(interview.groupId)}
                slotProps={{
                    primary: { variant: 'body2' },
                    secondary: { variant: 'caption' },
                }}
            />
        </ListItemButton>
    );
};

export default memo(InterviewListItem);
